// GET
export const GET_ACTIVITY = "GET_ACTIVITY"
export const GET_ACTIVITY_SUCCESS = "GET_ACTIVITY_SUCCESS"
export const GET_ACTIVITY_BY_ID = "GET_ACTIVITY_BY_ID"
export const GET_ACTIVITY_BY_ID_SUCCESS = "GET_ACTIVITY_BY_ID_SUCCESS"
// POST
export const POST_ACTIVITY = "POST_ACTIVITY"
export const POST_ACTIVITY_SUCCESS = "POST_ACTIVITY_SUCCESS"
// PATCH
export const PATCH_ACTIVITY_BY_ID = "PATCH_ACTIVITY_BY_ID"
export const PATCH_ACTIVITY_BY_ID_SUCCESS = "PATCH_ACTIVITY_BY_ID_SUCCESS"
// DELETE
export const DELETE_ACTIVITY_BY_ID = "DELETE_ACTIVITY_BY_ID"
export const DELETE_ACTIVITY_BY_ID_SUCCESS = "DELETE_ACTIVITY_BY_ID_SUCCESS"
